import { render, staticRenderFns } from "./DetalleSugerencia.vue?vue&type=template&id=e4068e58&scoped=true&"
import script from "./DetalleSugerencia.vue?vue&type=script&lang=js&"
export * from "./DetalleSugerencia.vue?vue&type=script&lang=js&"
import style0 from "./DetalleSugerencia.vue?vue&type=style&index=0&id=e4068e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4068e58",
  null
  
)

export default component.exports